import React, { FC, useMemo } from 'react'

import { MessagesDialog } from 'modules/Messages/components'
import { useMessages } from 'modules/Messages/serviceHooks'
import { isEmpty } from 'shared/utils/isEmpty'
import { ConditionRender } from 'components'

const MessagesDialogContainer: FC = () => {
  const { message, isFirstLogin, closeDialog } = useMessages()
  const isVisible = useMemo(() => isFirstLogin && message.active, [isFirstLogin, message.active])

  return (
    <ConditionRender
      condition={!isEmpty(message)}
      component={
        <MessagesDialog
          isVisible={isVisible}
          body={message.message}
          action={closeDialog}
          dataTest="sb-dialog"
          classList="sb-dialog"
        />
      }
    />
  )
}

export default MessagesDialogContainer
